import * as React from "react"
import Header from "../components/header"
import Footer from "../components/footer"
import Layout from "../components/layout"
import * as styles from "./index.module.scss"
import cover from "../../static/cover.png"

const Faq = ({ question, answer }) => {
  return (
    <div className={styles.faqItem}>
      <div className={styles.faqQuestion}>{question}</div>
      <div className={styles.faqAnswer}>{answer}</div>
    </div>
  )
}

class Index extends React.Component {
  componentDidMount() {
    const script = document.createElement("script")
    script.src = "https://paperform.co/__embed.min.js"
    script.async = true
    document.body.appendChild(script)
  }
  render() {
    return (
      <Layout title="Scholarship | Foundation 649">
        <Header />
        <div className={styles.hero}>
          <div className={styles.heroContent}>
            <div className={styles.name}>Foundation 649</div>
            is a 501c3 that discovers and empowers young, talented Asian
            Americans and Pacific Islanders who are actively elevating and
            serving their communities across the country.
            <br />
            <br />
            <a
              className={styles.applyBtn}
              href="https://docs.google.com/forms/d/e/1FAIpQLScMUWXvk9hVtnTziy_vLQwKKK5LSFC7KyM-wk3VphGfVqM4pA/viewform"
              target="_blank"
              rel="noopener noreferrer"
            >
              Apply Today
            </a>
          </div>
          <img className={styles.heroImg} src={cover} alt="Foundation 649" />
        </div>
        <div className={styles.scholarship}>
          <div className={styles.scholarshipContent}>
            <h3>2026 Scholarship Prompt</h3>
            <h2>
              Share a personal story through video that explores your AAPI
              identity by connecting with your roots, community, or the everyday
              moments that make you feel at home.
            </h2>
            <div className={styles.scholarshipDescription}>
              The Foundation 649 Scholarship is a grant of $4,000 over the
              course of 4 years that can be applied to college tuition and
              expenses. To maintain eligibility each year, there will be a brief
              check-in and renewal process at the end of each school year.
            </div>
            <div className={styles.scholarshipDetailSection}>
              <div className={styles.scholarshipDetailSectionTitle}>
                Details
              </div>
              <div className={styles.scholarshipDetailSectionContent}>
                <ul>
                  <li>Five recipients will be selected</li>
                  <li>
                    Each recipient will receive an award of $4,000 USD spread
                    over 4 years
                  </li>
                  <li>
                    The award must be renewed each year to receive successive
                    funds (details to come)
                  </li>
                  <li>Application deadline is March 1, 2026</li>
                  <li>
                    10 entrants will be selected as finalists for video call
                    interviews by March 31, 2026
                  </li>
                  <li>Recipients are announced by mid-April 2026</li>
                </ul>
              </div>
            </div>
            <div className={styles.scholarshipDetailSection}>
              <div className={styles.scholarshipDetailSectionTitle}>
                Requirements
              </div>
              <div className={styles.scholarshipDetailSectionContent}>
                <ul>
                  <li>
                    Be a degree-seeking, full-time student enrolling in a U.S.
                    accredited university in Fall 2026 as a Freshman or
                    transferring from a community college
                  </li>
                  <li>Identify as Asian American / Pacific Islander</li>
                  <li>
                    Have a track record of involvement and interest in AAPI
                    communities, issues, or causes
                  </li>
                  <li>Have demonstrated financial need for the scholarship</li>
                  <li>
                    Be a US citizen, resident, or foreign national. Undocumented
                    students are also welcome to apply.
                  </li>
                </ul>
              </div>
            </div>
            <div className={styles.scholarshipDetailSection}>
              <div className={styles.scholarshipDetailSectionTitle}>
                Application
              </div>
              <div className={styles.scholarshipDetailSectionContent}>
                The application consists of a video submission (link)
                responding to one of the three prompts below. We want to hear
                your stories - we encourage creativity, honesty, and originality
                (this should not be a rehash of your resume)! Your submission is
                based on its message and personal perspective, not fancy editing
                or film techniques. Simple, honest conversation is what matters
                most. Your video can be filmed on a phone, in any language, and
                can include subtitles if helpful. If you are selected as a
                recipient, with your permission, we plan to share your
                submission with our audiences. Videos should be between 1 and 5
                minutes long. Remember to focus on clarity and storytelling.
                Your message matters more than editing or length.
                <br />
                <br />
                <ul>
                  <li>
                    <strong>Intergenerational Conversations:</strong> Record a
                    short video conversation with a family member, mentor, or
                    community elder about what being AAPI means to them. Share
                    what you have learned and how it has shaped your own sense
                    of identity.
                  </li>
                  <li>
                    <strong>What Home Sounds Like:</strong> Capture or describe
                    the sounds that remind you of home such as family
                    conversations, street noises, cooking, music, or any
                    soundscape that carries meaning for you. Explain why these
                    sounds are important and how they connect to your AAPI
                    identity or sense of belonging.
                  </li>
                  <li>
                    <strong>Roots and Routes:</strong> Trace the journey of your
                    family or community (this can be across oceans, states, or
                    generations). Explain where your roots began and how those
                    paths have shaped who you are today. Reflect on what you
                    have or have not inherited, such as values or traditions,
                    and how those continue to grow in new places.
                  </li>
                </ul>
                <br />
                In addition, applicants should provide the FAFSA SAI (student
                aid index). If you are unable to provide this document, please
                provide substitute documentation and elaborate in the financial
                aid section.
                <a
                  className={styles.applyBtn}
                  href="https://docs.google.com/forms/d/e/1FAIpQLScMUWXvk9hVtnTziy_vLQwKKK5LSFC7KyM-wk3VphGfVqM4pA/viewform"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Apply Today
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.faq}>
          <div className={styles.faqContent}>
            <h2>FAQ</h2>
            <Faq
              question={
                "Is there a cutoff Student Aid Index or household income that determines eligibility?"
              }
              answer={
                "We recognize that applicants come from a variety of financial situations, and that neither the SAI or household income is a perfectly representative number. While they will factor heavily into our ultimate decision, we would also like to hear about additional financial context on you and will consider it as part of your application in a broader, holistic context."
              }
            />
            <Faq
              question={
                "Am I eligible if I am of ________ descent or if my parents are from ________?"
              }
              answer={
                "We recognize that there may be cases in which a candidate identifies as AAPI but don't fall neatly into a familial bucket, e.g. adoptees. Generally, if you are of AAPI descent and resonate with Foundation 649's mission, we encourage you to apply. However, don't hesitate to email us if you have specific eligibility questions."
              }
            />
            <Faq
              question={"Where do I find my FAFSA SAI?"}
              answer={
                "After you submit your Free Application for Federal Student Aid (FAFSA) form, you will receive a FAFSA Submission Summary that provides an overview of the information you provided on your FAFSA form. For more detailed instructions, please visit https://studentaid.gov/help-center/answers/article/what-is-sai."
              }
            />
            <Faq
              question={"What if I haven't received my FAFSA SAI yet?"}
              answer={
                "If for any reason you don't have a FAFSA, please upload income information, such as W2, 1099s, tax returns and elaborate in the question below. We may reach out for additional documentation."
              }
            />
            <div className={styles.otherQuestions}>
              Questions? Please contact us at{" "}
              <a href="mailto:team@foundation649.com">team@foundation649.com</a>
              .
            </div>
          </div>
        </div>
        <Footer />
      </Layout>
    )
  }
}

export default Index
